"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PillList = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var design_system_typography_1 = require("@contrast-security-inc/design-system-typography");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var Pill_1 = require("../Pill");
var messages = __importStar(require("../translations"));
var styles_1 = require("./styles");
exports.PillList = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var pills = _a.pills, testId = _a.testId, rest = __rest(_a, ["pills", "testId"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var innerRef = react_1.default.useRef(null);
    var _c = react_1.default.useState(0), width = _c[0], setWidth = _c[1];
    var _d = react_1.default.useState(false), seeMore = _d[0], setSeeMore = _d[1];
    var _e = react_1.default.useState(0), pillsToDisplay = _e[0], setPillsToDisplay = _e[1];
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    var onSeeMoreClick = function () { return setSeeMore(function (prev) { return !prev; }); };
    var updateWidth = function () {
        var _a, _b;
        setWidth((_b = (_a = innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0);
    };
    react_1.default.useEffect(function () {
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return function () {
            window.removeEventListener('resize', updateWidth);
        };
    }, []);
    /** An array containing the width of each pill (incl gap) */
    var pillWidths = react_1.default.useMemo(function () {
        var _a;
        return Array.from(((_a = innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) === null || _a === void 0 ? void 0 : _a.children) || []).map(function (pill) {
            return Math.ceil(pill.getBoundingClientRect().width + styles_1.gapWidth);
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [(_b = innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) === null || _b === void 0 ? void 0 : _b.children]);
    /** Calculate the number of pills to display based on the container width */
    var getPillsToDisplay = react_1.default.useCallback(function () {
        var accCanAddPill = true;
        var accWidth = 0;
        var count = 0;
        var seeMorePillWidth = 7 * String(count).length + 32; // 7px for each number and 32px for initial size
        pillWidths.forEach(function (pillWidth, index) {
            if (pills.length === 1) {
                count = 1;
                return;
            }
            var isSmallContainer = index === 0 && pillWidths[0] + seeMorePillWidth > width;
            var hasMorePillsToAdd = index < pillWidths.length - 1;
            var widthInclCurrPill = accWidth + pillWidth + (hasMorePillsToAdd ? seeMorePillWidth : 0);
            var canAddPill = widthInclCurrPill <= width;
            if (!canAddPill || isSmallContainer || !accCanAddPill) {
                accCanAddPill = false;
                return;
            }
            accWidth += pillWidth;
            count += 1;
        });
        return count;
    }, [pillWidths, pills.length, width]);
    react_1.default.useEffect(function () {
        if ((innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) && width > 0) {
            setPillsToDisplay(getPillsToDisplay());
        }
    }, [pills, seeMore, width, pillWidths, getPillsToDisplay]);
    var hiddenPillsCount = react_1.default.useMemo(function () { return pills.length - pillsToDisplay; }, [pills, pillsToDisplay]);
    var display = react_1.default.useMemo(function () { return (seeMore ? pills : pills.slice(0, pillsToDisplay)); }, [pills, pillsToDisplay, seeMore]);
    var renderDisplayActions = seeMore ? (react_1.default.createElement("button", { className: styles_1.buttonResetCss, onClick: onSeeMoreClick, type: "button" },
        react_1.default.createElement(design_system_typography_1.Link, { className: (0, css_1.cx)(styles_1.whiteSpaceNoWrapCss, styles_1.seeLessLinkCss), testId: "".concat(testId, "-see-less-link") },
            react_1.default.createElement(design_system_foundations_1.IconCaretUp, { color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral100', dark: 'darkTheme.white' }) }),
            react_1.default.createElement(design_system_typography_1.Text, { font: "metadata" },
                " ",
                formatMessage(messages, 'action_seeLess'))))) : (react_1.default.createElement(Pill_1.Pill, { className: styles_1.whiteSpaceNoWrapCss, onClick: onSeeMoreClick, testId: "".concat(testId, "-see-more-pill"), text: "+ ".concat(hiddenPillsCount), key: "see-more-pill", color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral10', dark: 'darkTheme.black' }), textColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'turquoise90', dark: 'darkTheme.teal100' }) }));
    return (react_1.default.createElement("div", { className: styles_1.containerCss },
        react_1.default.createElement("ul", { "aria-hidden": "true", "data-testid": "".concat(testId, "-hidden"), ref: innerRef, className: (0, css_1.cx)(rest.className, styles_1.pillListCss, styles_1.pillListHiddenCss) }, pills.map(function (pill, index) { return (react_1.default.createElement("li", { key: "".concat(pill, "-").concat(index, "-hidden") },
            react_1.default.createElement(Pill_1.Pill, { className: styles_1.whiteSpaceNoWrapCss, text: pill }))); })),
        react_1.default.createElement("ul", __assign({ "data-testid": testId, ref: ref }, rest, { className: (0, css_1.cx)(rest.className, styles_1.pillListCss, 'ds-pill-list') }),
            display.map(function (pill, index) { return (react_1.default.createElement("li", { key: "".concat(pill, "-").concat(index) },
                react_1.default.createElement(Pill_1.Pill, { className: styles_1.whiteSpaceNoWrapCss, text: pill }))); }),
            hiddenPillsCount > 0 ? react_1.default.createElement("li", { className: styles_1.displayActionsCss }, renderDisplayActions) : null)));
});
exports.PillList.displayName = 'PillList';
